import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Section, Container } from "@/components/Layout";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const { refresh } = useAuth();

  useEffect(() => {
    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    if (!sid) { nav("/login"); return; }

    // idempotent single-run
    let cancelled = false;
    (async () => {
      try {
        await api.post("/auth/session", { session_id: sid });
        if (cancelled) return;
        // clear hash then continue
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        nav("/dashboard", { replace: true });
      } catch (e) {
        nav("/login?error=session");
      }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Section className="pt-52 pb-52">
      <Container>
        <div className="text-center">
          <div className="overline">Signing you in</div>
          <div className="mt-6 font-serif-display text-3xl">Welcome to Wolfkeeper.</div>
          <div className="mt-4 text-[color:var(--wk-bone-dim)]">Preparing your dashboard…</div>
        </div>
      </Container>
    </Section>
  );
}
